import { render, staticRenderFns } from "./model.page.vue?vue&type=template&id=6f0405ee&scoped=true&"
import script from "./model.page.vue?vue&type=script&lang=js&"
export * from "./model.page.vue?vue&type=script&lang=js&"
import style0 from "./model.page.vue?vue&type=style&index=0&id=6f0405ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f0405ee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\mzkj\\要炼\\yl-pc-business\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f0405ee')) {
      api.createRecord('6f0405ee', component.options)
    } else {
      api.reload('6f0405ee', component.options)
    }
    module.hot.accept("./model.page.vue?vue&type=template&id=6f0405ee&scoped=true&", function () {
      api.rerender('6f0405ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/trade/comment/model.page.vue"
export default component.exports